var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#EAF3FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.39844,
    y: 11.6445,
    width: 2.8,
    height: 4.2,
    rx: 0.42,
    fill: "#3284FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6016,
    y: 8.84766,
    width: 2.8,
    height: 7,
    rx: 0.42,
    fill: "#3284FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.8008,
    y: 6.04688,
    width: 2.8,
    height: 9.8,
    rx: 0.42,
    fill: "#3284FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.9492H19",
    stroke: "#3284FF",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnGraph);
export default __webpack_public_path__ + "static/media/btn_graph.4a23131a27d857aada8f1cfb25bd4875.svg";
export { ForwardRef as ReactComponent };